const string_to_array = (str, sep) => {
    return str.split(sep);
}

const array_to_string = (arr) => {
    return arr.toString();
}

export { string_to_array, array_to_string }